/**
 * Utilitários para lógica de fornecedor
 */

import type {
  FornecedorRaw,
  FornecedorComboboxItem,
} from "@apiInclui/fornecedor";

// -----------------------------------------------------------------------------
// Criação de combo item
// -----------------------------------------------------------------------------
export const createComboItem = (
  fornecedor: FornecedorRaw
): FornecedorComboboxItem => ({
  uniqueId: `${fornecedor.A2_COD}-${fornecedor.A2_LOJA}`,
  cod: fornecedor.A2_COD,
  loja: fornecedor.A2_LOJA,
  nome: fornecedor.A2_NOME,
  cnpj: fornecedor.A2_CGC || "",
  original: fornecedor,
});

// -----------------------------------------------------------------------------
// Busca por CNPJ exato
// -----------------------------------------------------------------------------
export const findExactCnpjMatch = (
  searchResults: FornecedorRaw[],
  targetCnpj: string
): FornecedorRaw | null => {
  if (!searchResults?.length || !targetCnpj?.trim()) return null;

  const cnpjLimpo = targetCnpj.replace(/\D/g, "");

  return (
    searchResults.find((forn) => {
      const fornCnpjLimpo = forn.A2_CGC?.replace(/\D/g, "") || "";
      return fornCnpjLimpo === cnpjLimpo || forn.A2_CGC === targetCnpj;
    }) || null
  );
};

// -----------------------------------------------------------------------------
// Verificação de match exato para seleção rápida
// -----------------------------------------------------------------------------
export const isExactMatch = (
  term: string,
  item: FornecedorComboboxItem
): boolean => {
  const trimmed = term.trim();
  return (
    trimmed === item.cod ||
    trimmed.toLowerCase() === item.nome.toLowerCase() ||
    trimmed === item.cnpj
  );
};

// -----------------------------------------------------------------------------
// Ordenação de opções (item selecionado primeiro)
// -----------------------------------------------------------------------------
export const sortOptionsWithSelectedFirst = (
  options: FornecedorComboboxItem[],
  selectedItem: FornecedorComboboxItem | null
): FornecedorComboboxItem[] => {
  if (!selectedItem) return options;

  // Tenta encontrar por código/loja primeiro
  let selectedIndex = options.findIndex(
    (opt) => opt.cod === selectedItem.cod && opt.loja === selectedItem.loja
  );

  // Se não encontrou, tenta por CNPJ
  if (selectedIndex === -1 && selectedItem.cnpj) {
    selectedIndex = options.findIndex((opt) => opt.cnpj === selectedItem.cnpj);
  }

  if (selectedIndex !== -1) {
    // Remove o item selecionado da posição atual
    const [selectedOption] = options.splice(selectedIndex, 1);
    // Coloca no início da lista
    options.unshift(selectedOption);
  }

  return options;
};
